module.exports = __webpack_public_path__ + "img/syukyaku-top-GHmark.c83faa15.png";